import * as React from "react";
import { Routes, Route } from "react-router-dom";
import AppLayout from "../AppLayout";
import HrAttendance from "../AttendanceComponent";
import AttendanceTable from "../AttendanceTable";
import StudentList from "../StudentList";
import CourseCard from "../CourseCard";
import ViewFeesComponent from "../ViewFeesComponent";
import FeeHistory from "../FeeHistory";
import BatchCreationDialog from "../BatchCreationDialog";
import AttendanceHistory from "../AttendanceHistory";
import StudentProfile from "../StudentProfile";
import Error404 from "../Error404";
import InstructorDashboard from "../Instructor/Dashboard";
import ResizableSections from "../Ranking/ResizableSections";

export default function InstructorRoute() {
  return (
    <Routes>
      {/* Layout Route for Admin */}
      <Route path="ranking" element={<ResizableSections />} />

      <Route path="/" element={<AppLayout />}>
        {/* Nested Routes for Admin Dashboard */}
        <Route index element={<InstructorDashboard />} />
        <Route path="/:username" element={<StudentProfile />} />
        {/* <Route path="ranking" element={<ResizableSections />} /> */}
        <Route path="attendance" element={<HrAttendance />} />
        <Route path="attendance/:id" element={<AttendanceTable />} />
        <Route path="attendancehistory/:id" element={<AttendanceHistory />} />
        <Route path="view-fee" element={<ViewFeesComponent />} />
        <Route path="feehistory/:id" element={<FeeHistory />} />
        <Route path="batch" element={<BatchCreationDialog />} />
        <Route path="courses" element={<CourseCard />} />
        <Route path="students" element={<StudentList />} />
        <Route path="*" element={<Error404 />} />
      </Route>
    </Routes>
  );
}
